import React, { useEffect, useState } from 'react';
import { get, clamp } from 'lodash';
import PropTypes from 'prop-types';

export const Spinner = (props) => {
  const className = get(props, 'className');
  const onColor = get(props, 'onColor', '#60151E');
  const offColor = get(props, 'offColor', '#DDD9D5');
  const dots = get(props, 'dots', 10);
  const size = get(props, 'size', 24);
  const dotSize = get(props, 'dotSize', 2);
  const radius = size / 2;

  let interval = 0;
  const [spin, setSpin] = useState(0);

  useEffect(() => {
    interval = window.setInterval(() => {
      const newSpin = spin + 360 / dots;
      setSpin(newSpin > 360 ? newSpin - 360 : newSpin);
    }, 150);

    return () => {
      window.clearInterval(interval);
    };
  });

  const mod = (a, b) => a - Math.floor(a / b) * b;

  const renderDots = () => {
    const step = (2 * Math.PI) / dots;

    return Array.from({ length: dots }, (_, index) => {
      const angle = index * step;
      const x = (radius - dotSize) * Math.cos(angle) + radius;
      const y = (radius - dotSize) * Math.sin(angle) + radius;
      const minDistance = 360 / 2;
      const aDistance = mod((angle * 180) / Math.PI - spin + 180, 360) - 180;
      const trail = aDistance <= 0 ? (Math.abs(aDistance) < minDistance ? Math.abs(aDistance) / minDistance : 1) : 1;
      const colorIntensity = 1 - trail * 0.5;

      return (
        <circle
          opacity={clamp(colorIntensity, 0.5, 1)}
          key={index}
          cx={x}
          cy={y}
          r={dotSize}
          fill={colorIntensity > 0.5 ? onColor : offColor}
        />
      );
    });
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="spinner"
    >
      {renderDots()}
    </svg>
  );
};

Spinner.propTypes = {
  className: PropTypes.string,
  dots: PropTypes.number,
  size: PropTypes.number,
  dotSize: PropTypes.number,
  onColor: PropTypes.string,
  offColor: PropTypes.string,
};
